// extracted by mini-css-extract-plugin
export default {"wrap":"Todo_wrap__lX2Sv","checkbox":"Todo_checkbox__uKuLr","edit":"Todo_edit__ARiYM","buttons":"Todo_buttons__ZEF1h","button":"Todo_button__6pyFo"};